import { memo, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

/**
 * Lightweight wrapper for core app pages.
 * The actual gradient backdrop lives at the App layout level (AppBackdrop)
 * so it's outside all transform contexts and never re-renders on tab switches.
 */
export const PageShell = memo(({ children, className }: PageShellProps) => (
  <div className={cn('app-shell relative z-[1] text-foreground', className)}>{children}</div>
));
PageShell.displayName = 'PageShell';

/**
 * App-level backdrop gradient. Rendered ONCE in the App layout,
 * outside PullToRefresh / Motion transform contexts.
 */
export const AppBackdrop = memo(() => (
  <div className="page-shell-backdrop" aria-hidden="true" />
));
AppBackdrop.displayName = 'AppBackdrop';
